// Copyright (C) 2021 TANNER AG

import React from "react";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import EMobilityMarkdown from "./EMobilityMarkdown";

const styles = (theme) => ({
    container: {
        paddingTop: 20,
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: 20,
    },
    root: {
        display: "flex",
        marginTop: 20,
        marginBottom: 40,
        justifyContent: "space-between",
    },
    label: {
        fontFamily: "'MANEurope', sans-serif",
        textTransform: "uppercase",
        fontWeight: 700,
        color: "#303C49",
        fontSize: "1.75rem",
        marginBottom: "1rem",
    },
    content: {
        padding: "1.625rem 0",
        flexGrow: 1,
    },
    bracket: {
        border: "0.125rem solid #abb6c3",
        width: "1.125rem",
    },
    bracketLeft: {
        borderRightWidth: 0,
        marginRight: "0.375rem",
    },
    bracketRight: {
        borderLeftWidth: 0,
        marginLeft: "0.375rem",
    },
});

const MANInfo = ({ content, classes }) => {
    return (
        <div className={classes.root}>
            <div className={classnames(classes.bracket, classes.bracketLeft)} />
            <div className={classes.content}>
                <div className={classes.label}>MAN Info</div>
                <EMobilityMarkdown content={content} />
            </div>
            <div className={classnames(classes.bracket, classes.bracketRight)} />
        </div>
    );
};

export default withStyles(styles)(MANInfo);



// WEBPACK FOOTER //
// ./src/emobility/MANInfo.js